import * as angular from 'angular';

import { IntervalValidationService } from '../../services/helpers/intervalValidation.service';
import { ComponentDefinition, PropertyType, IFrequency } from '../../models/index';

class FieldValueSelectorController implements angular.IComponentController {
    allType = PropertyType;
    disabled: boolean;
    extraData: { [index: string]: any };
    formController: angular.IFormController;
    frequencyValidationRules: any[];
    isLoading: boolean;
    model: any;
    modernDesign = false;
    name: string;
    onChange: (value) => void;
    parentModel: any;
    required: boolean;
    type: number;

    static $inject = [
        'intervalValidationService'
    ];

    constructor(private _intervalValidationService: IntervalValidationService) {
    }

    $onInit() {
        this.updateExtraData();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['extraData']) {
            this.updateExtraData();
        }
    }

    updateExtraData() {
        if (!this.extraData) {
            this.extraData = {};
        }
        if (!this.extraData['intervalUnitName']) {
            this.extraData['intervalUnitName'] = 'intervalTimeUnit';
        }

        this.frequencyValidationRules = [];

        if (!this.extraData['disableFrequencyValidation']) {
            if (!this.extraData['frequencyValidationRules']) {
                this.frequencyValidationRules.push({
                    key: 'interval',
                    isValid: this.getValidationMethod()
                });
            } else {
                this.frequencyValidationRules = this.extraData['frequencyValidationRules'];
            }
        } else {
            if (this.extraData['frequencyValidationRules']) {
                delete this.extraData['frequencyValidationRules'];
            }
            this.frequencyValidationRules = [];
        }
    }

    private getValidationMethod() {
        const allowZero = (!this.extraData['allowFrequencyIntervalZero'] && this.extraData['allowFrequencyIntervalZero'] !== false)
            ? true
            : !!this.extraData['allowFrequencyIntervalZero'];
        const allowEmpty = (!this.extraData['allowFrequencyIntervalEmpty'] && this.extraData['allowFrequencyIntervalEmpty'] !== false)
            ? false
            : !!this.extraData['allowFrequencyIntervalEmpty'];
        let validationMethod: (frequency: IFrequency) => boolean;
        if (!allowZero && !allowEmpty) {
            validationMethod = (frequency) => this._intervalValidationService.isValidStrict(frequency);
        } else if (allowZero && !allowEmpty) {
            validationMethod = (frequency) => this._intervalValidationService.isValid(frequency);
        } else if (!allowZero && allowEmpty) {
            validationMethod = (frequency) => this._intervalValidationService.isValidAllowEmpty(frequency);
        } else if (allowZero && allowEmpty) {
            validationMethod = (frequency) => this._intervalValidationService.isValidAllowEmptyAndZero(frequency);
        }
        return validationMethod;
    }
}

export const wtFieldValueSelector: ComponentDefinition = {
    componentId: 'wtFieldValueSelector',
    controller: FieldValueSelectorController,
    template: require('./fieldValueSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        disabled: '<?',
        extraData: '<?',
        formController: '=?',
        frequencyValidationRules: '<?',
        maxLength: '<?',
        model: '=',
        modernDesign: '<?',
        name: '@',
        onChange: '&?',
        parentModel: '=?',
        placeholder: '<?',
        required: '<?',
        type: '<',
        variableTypeGuid: '=?'
    }
};